<template>
  <span
    :class="{ 'sb-pagination__placeholder': isPlaceholder }"
    data-testid="pagination-items-information"
  >
    {{ text }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import i18n from '../../../i18n/index'

type PaginationItemsText = {
  currentPage?: number
  isPlaceholder?: boolean
  pages?: number
  perPage?: number
  total?: number
  locale?: string
}

const props = withDefaults(defineProps<PaginationItemsText>(), {
  currentPage: 1,
  isPlaceholder: false,
  pages: 10,
  perPage: 10,
  total: 100,
  locale: 'en',
})

const text = computed(() => {
  const { currentPage, pages, perPage, total, locale } = props
  const isTheLastPage = currentPage === pages
  const currentPageItems = currentPage * perPage
  const firstCurrentPageItem =
    currentPage === 1 ? 1 : currentPageItems - perPage + 1
  const lastCurrentPageItem =
    currentPage === 1 ? perPage : isTheLastPage ? total : currentPageItems

  const ofTranslated = i18n(locale, 'of')
  const itemsTranslated = i18n(locale, 'items')

  if (firstCurrentPageItem === 1 && lastCurrentPageItem >= total) {
    return `${firstCurrentPageItem}-${total} ${ofTranslated} ${total} ${itemsTranslated}`
  } else {
    return `${firstCurrentPageItem}-${lastCurrentPageItem} ${ofTranslated} ${total} ${itemsTranslated}`
  }
})
</script>
